import $ from 'jquery';
import moment from 'moment';
import React, { useState, useEffect, useRef } from 'react';
import ReactGA from 'react-ga4';
import Swipeable from 'react-swipeable';
import Modal from '../../components/bootstrap4/Modal';
import Loading from '../../components/Loading';
import LazyLoadImage from '../../components/LazyLoadImage';
import SessionManager from '../../routes/SessionManager';
import ZoneHistoryImage from './ZoneHistoryImage';
import ZoneSensorBattery from './ZoneSensorBattery';
import ZoneHistoricalVideo from './ZoneHistoricalVideo';
import video_icon from '../../assets/img/video-icon.png';
import no_image from './../../assets/img/no-image.png';
import { Tooltip } from 'antd';
import XMLParser from 'react-xml-parser';
import AppConfig from '../../config/AppConfig';
import Toastr from 'toastr';
import CommonUtils from '../../util/CommonUtils';

const COLORS = { 'WORK': '#888888', 'OFFWORK': '#2d3138eb', 'PEOPLE': 'rgba(9,109,217)', 'LINE': '#eeeeee', 'VEHICLE': 'rgb(255, 165, 0)' };
const ZoneHistoryCarousel = (props) => {
  let video_ref = useRef(null);

  const [slidePos, setSlidePos] = useState(0);
  const [labels, setLabels] = useState(null);
  const [datasets, setDatasets] = useState(null);
  const [zone_history, setZoneHistory] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const [thumbnailWidth, setThumbnailWidth] = useState(100);
  const [holidayFetchComplete, setHolidayFetchComplete] = useState(false);
  const [recording, setRecording] = useState(null);
  const [timestamps, setTimestamps] = useState([]);
  const [workHourMap, setWorkHourMap] = useState([]);
  const [maxSize, setMaxSize] = useState(null);
  const [history_recs, setHistoryRecs] = useState(null);

  let sessionMgr = new SessionManager();
  let user = sessionMgr.readCookie('user');

  let timezone = user.site_selected.site_iana_timezone;
  if (!timezone)
    timezone = moment.tz.guess();

  const [date, setDate] = useState(user.ai_event ? moment.tz(user.ai_event.sec_timestamp * 1000, timezone).format('YYYY-MM-DD') : props.date);
  let is_axis_camera = user.zone_selected.location_device_type && ['axis', 'uniview'].includes(user.zone_selected.location_device_type);

  useEffect(() => {
    if (props && holidayFetchComplete) {
      setDate(props.date);
    }
    calcualteThumbnailDimensions();
    getHolidaysList();
    if (is_axis_camera) {
      getRecordingId();
    }
  }, [props]);

  useEffect(() => {
    if (props && holidayFetchComplete) {
      fetchZoneHistory();
    }
  }, [date]);

  let getHolidaysList = (attempts = 3) => {
    let holiday_config = AppConfig.getConfigParameter('holidays', 'holidays');
    if (!holiday_config) {
      if (attempts > 0) {
        setTimeout(() => {
          getHolidaysList(--attempts);
        }, 3000);
      }
    } else {
      let site_id = user.site_selected.site_id;
      let holidays = [];
      for (let h of ['default', String(site_id)])
        if (holiday_config[h])
          holidays = holidays.concat(holiday_config[h].filter(x => {
            if (h !== 'default')
              x.site_level = true;
            return x.exclude ? !x.exclude.includes(String(site_id)) : true;
          }));
      setHolidays(holidays);
      setHolidayFetchComplete(true);
    }
  }

  useEffect(() => {
    if (holidayFetchComplete) {
      refreshZoneHistory();
    }
  }, [holidayFetchComplete]);


  let getDVRDetails = () => {
    Toastr.info('Fetching dvr details ...');
    $.ajax({
      url: "https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/axis-camera/dvr-details",
      type: 'POST',
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      headers: {
        user_login: user.user_login,
        user_token: user.user_token
      },
      data: JSON.stringify({ device_id: user.zone_selected.device_id }),
      success: function (response) {
        if (response.status.code === 200) {
          let disks = null;
          try {
            let dvrDetailsJSON = new XMLParser().parseFromString(response.data);
            let disksInfos = dvrDetailsJSON.getElementsByTagName('disks');

            if (disksInfos && disksInfos.length > 0) {
              if (!disksInfos[0].children || disksInfos[0].children.length === 0) {
                Toastr.error('No DVR disks found');
                return;
              }

              let hasSDDisk = false;
              for (let disksInfo of disksInfos[0].children) {
                let disk = disksInfo.attributes;
                if (disk.hasOwnProperty('readonly') && disk['diskid'] === 'SD_DISK') {
                  hasSDDisk = true;
                  if (disk['readonly'] !== 'no') {
                    Toastr.warning('DVR is locked and needs to be changed to read/write');
                  } else {

                    console.log({
                      'diskid': disk['diskid'],
                      'size': disk['totalsize'],
                      'free': disk['freesize'],
                      'status': disk['readonly']
                    });

                    if (parseInt(disk['totalsize']) < 200000000) {
                      Toastr.error('Wrong disk size detected.');
                    } else {
                      Toastr.success('A DVR disk is detected and has total size of ' + (disk['totalsize'] / 1000000).toFixed(2) + ' MB');
                    }
                  }
                }
              }
              if (!hasSDDisk) {
                Toastr.error('No DVR disks found');
              }

              sessionMgr.storeCookie('user', { ...user });
            } else {
              Toastr.error('No DVR disks found');
            }

          } catch (e) {
            Toastr.error('Error occurred while fetching DVR details');
          }
          console.log('dvr-details', disks);




        } else {
          Toastr.error('No DVR found')
        }
      },
      error: function (xhr, status) {
        console.error("Error fetching DVR details", status);
      }
    });
  }

  let getRecordingId = () => {
    $.ajax({
      url: "https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/axis-camera/recordings",
      type: 'POST',
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      headers: {
        user_login: user.user_login,
        user_token: user.user_token
      },
      data: JSON.stringify({ device_id: user.zone_selected.device_id }),
      success: function (response) {
        if (response.status.code === 200) {
          let recordingsJSON = new XMLParser().parseFromString(response.data);
          let recordings = recordingsJSON.getElementsByTagName('recording');
          setRecording(getRecording(recordings));
        } else {
          setRecording(null);
        }
      },
      error: function (xhr, status) {
        setRecording(null);
      }
    });
  }

  let refreshZoneHistory = () => {
    fetchZoneHistory();
  }

  let fetchZoneHistory = () => {
    if (!date) {
      return
    }
    setSlidePos(0);
    setZoneHistory([]);
    setHistoryRecs(null);

    var data = {
      customer_id: user.customer_id,
      site_id: user.site_selected.site_id,
      user_login: user.user_login,
      user_token: user.user_token,
      from: date,
      to: date,
      location_id: user.zone_selected.location_id,
      timezone: timezone,
      api_new: true,
      tracker_history: true
    };

    $.ajax(
      {
        url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/zone-history',
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(data)
      }
    ).then(
      async (res) => {
        if (res.status && res.status.code === 200) {
          if (res.data && res.data.data_ref) {
            let response = await fetch(res.data.data_ref, { headers: { 'Accept': 'application/json' } });
            let json = await response.json();
            res.data = json;
          }

          var history_recs = res.data;
          history_recs = history_recs.sort((x, y) => (moment.tz(x.sec_timestamp * 1000, timezone) - moment.tz(y.sec_timestamp * 1000, timezone)))

          let recs = {};
          for (let rec of history_recs) {
            if (!rec.dev_timestamp || rec.dev_timestamp === undefined)
              rec.dev_timestamp = rec.sec_timestamp;

            recs[moment.tz(rec.dev_timestamp * 1000, timezone).format('YYYY-MM-DD HH:mm:ss').toUpperCase()] = rec;
          }

          COLORS.WORK_PATTERN = createPattern(COLORS.WORK);

          let time_stamps = [];
          let labels = [];
          let datasets = [[], [], [], [], []];
          let ai_event_pos = -1;
          let slidePos = -1;
          let work_hour_map = [];


          let zone_selected = user.zone_selected;
          let people_detection = zone_selected && zone_selected.location_config && zone_selected.location_config.feature_controls && zone_selected.location_config.feature_controls.motion_detection && zone_selected.location_config.feature_controls.motion_detection.enabled;
          let vehicle_detection = zone_selected && zone_selected.location_config && zone_selected.location_config.feature_controls && zone_selected.location_config.feature_controls.vtracking && zone_selected.location_config.feature_controls.vtracking.enabled;

          console.log('site_id: ' + data.site_id + ', location_id: ' + data.location_id + ', ai_event: ' + (user.ai_event && user.ai_event.sec_timestamp));

          let prevRec = { image: null, image_thumbnail: null };
          for (let rec of Object.values(recs)) {
            // incase of video with no image, then use prev image and image_thumbnail.
            rec.image = rec.image ? rec.image + ('x-amz-security-token=' + rec.x_amz_security_token) : prevRec.image;
            rec.video = rec.video ? rec.video + ('x-amz-security-token=' + rec.x_amz_security_token) : null;
            rec.image_thumbnail = rec.image_thumbnail ? rec.image_thumbnail + ('x-amz-security-token=' + rec.x_amz_security_token) : prevRec.image_thumbnail;

            prevRec = rec;
            prePopulateTempWeather(rec);
            slidePos++;
            time_stamps.push(rec.sec_timestamp);
            var HHmm = moment.tz(rec.dev_timestamp * 1000, timezone).format('HH:mm').toUpperCase();
            labels.push(HHmm);

            if (HHmm === '22:31') {
              console.log('Rec', rec);
            }

            datasets[0].push(rec.has_video ? 1 : null);
            datasets[4].push(rec.tracks_count ? 1 || rec.tracks_count : 0);

            let bboxes = rec.bbox_info ? JSON.parse(rec.bbox_info) : [];
            if (isWorkHours(rec.dev_timestamp, user.site_selected)) {
              work_hour_map.push(COLORS.WORK_PATTERN);
              datasets[1].push(bboxes && people_detection !== false ? bboxes.filter(b => b.c === 'person').length : 0);
              datasets[2].push(bboxes ? bboxes.filter(b => b.c !== 'person').length : 0);
            } else {
              work_hour_map.push(COLORS.OFFWORK);
              datasets[1].push(bboxes && people_detection !== false ? bboxes.filter(b => b.c === 'person').length : 0);
              datasets[2].push(bboxes ? bboxes.filter(b => b.c !== 'person').length : 0);
            }

            datasets[3].push(1);
            setTimestamps(time_stamps);
            setWorkHourMap(work_hour_map);
            if (user.ai_event && ai_event_pos === -1) {
              if ((user.ai_event && user.ai_event.sec_timestamp === rec.sec_timestamp) || (user.ai_event && user.ai_event.sec_timestamp === rec.dev_timestamp) || (user.ai_event && user.ai_event.timestamp === rec.sec_timestamp))
                ai_event_pos = slidePos;
              else {
                if (user.ai_event && rec.dev_timestamp > user.ai_event.sec_timestamp) {
                  ai_event_pos = slidePos;
                }
              }
            }
          }

          if (ai_event_pos > -1) {
            slidePos = ai_event_pos;
            delete user.ai_event;
            let sessionManagerObj = sessionMgr;
            sessionManagerObj.storeCookie('user', { ...user });
          }

          let max_size = Math.max(...datasets[1], ...datasets[2], ...datasets[4]) || 3
          max_size = max_size + 3;

          if (history_recs && max_size > 0) {
            for (let i in datasets[0]) {
              let p = datasets[1][i];
              let t = datasets[2][i];
              if (vehicle_detection === false) {
                history_recs[i].tracks_count = 0;
              } else {
                if (p > t) {
                  datasets[3][i] = p - t;
                  datasets[4][i] = t;
                } else {
                  datasets[3][i] = p;
                  datasets[4][i] = t - p;
                }
              }

            }
          }
          setMaxSize(max_size);
          // setRecording(getRecording());
          setSlidePos(slidePos);
          setLabels(labels);
          setDatasets(datasets);
          setHistoryRecs(Object.values(recs));
          setZoneHistory([]);
          $("[data-toggle='tooltip']").tooltip(); // callback

        }
      },
      (res) => {

      });
  }

  let getRecording = (recording) => {
    if (recording !== undefined && recording && recording.length > 0) {
      if (recording.length > 1)
        recording = recording.sort((a, b) => b.attributes['starttime'] > a.attributes['starttime'] ? -1 : b.attributes['starttime'] < a.attributes['starttime'] ? 1 : 0);
    }
    return recording;
  }

  let prePopulateTempWeather = (rec) => {
    if (!rec.sensor_info)
      return;

    var sensor_info = JSON.parse(rec.sensor_info);
    sensor_info.filter((x) => {
      if ((x.sensor_id === 'temperature' || x.sensor_id === 'humidity')) {
        rec[x.sensor_id] = (Math.round(x.value_float * 100, 2) / 100);
        return true;
      }
      return false;
    });
  }

  // let onVideoThumbnailClick = (imgCSS) => {
  //   $('.' + imgCSS).trigger('click');
  // }

  let onImageThumbnailClick = (e) => {
    var slidePos = e.target.getAttribute('pos');
    setSlidePos(parseInt(slidePos));

    ReactGA.event({
      category: 'Navigation',
      action: 'Click ZoneCarousel Item',
      label: 'ZoneCarousel Item in ' + user.zone_selected.location_id + ' for ' + date
    });
  };

  let onNextClick = (e) => {
    $('.bbox').remove();

    let curr_pos = slidePos;
    let max_pos = history_recs.length - 1;

    if (curr_pos === max_pos) {
      curr_pos = 0;
    } else {
      curr_pos = curr_pos + 1;
    }
    setSlidePos(curr_pos);

    ReactGA.event({
      category: 'Navigation',
      action: 'Swipe ZoneCarousel Next Button',
      label: 'ZoneCarousel Next in ' + user.zone_selected.location_id + ' for ' + date
    });
  }

  let onPrevClick = (e) => {
    $('.bbox').remove();

    let curr_pos = slidePos;
    let max_pos = history_recs.length - 1;

    if (curr_pos === 0) {
      curr_pos = max_pos;
    } else {
      curr_pos = curr_pos - 1;
    }
    setSlidePos(curr_pos);

    ReactGA.event({
      category: 'Navigation',
      action: 'Swipe ZoneCarousel Previous Button',
      label: 'ZoneCarousel Previous in ' + user.zone_selected.location_id + ' for ' + date
    });
  }

  let calcualteThumbnailDimensions = () => {
    if ($('#carousel_container').length > 0) {
      let thumbnail_width = ($('#carousel_container')[0].clientWidth / 6);
      setThumbnailWidth(thumbnail_width);
    }
  }

  let applyBoundingBoxes = () => {
    $('.bbox').remove();
    let currentImage = $('#zone-image');
    if (!currentImage[0])
      return;

    slideThumbnails();
    let chartWindow = [$('.chart_slider')[0].scrollLeft, $('.chart_slider')[0].scrollLeft + (6 * thumbnailWidth)];
    if (slidePos * 50 > chartWindow[1] || slidePos * 50 < chartWindow[0])
      $('.chart_slider').animate({ scrollLeft: slidePos * 50 - (6 * thumbnailWidth) * 0.5 }, 500);


    if ($(currentImage).parent().width() < 600) {
      $('.video-icon').height(24);
      $('.video-icon').width(32);
    }

    for (let el of $('.align-vc'))
      $(el).css('margin-top', ($(currentImage).parent().height() * 0.5 - $(el).height() * 0.5) + 'px');

    $('.video-btn').css('top', ($(currentImage).parent().height() * 0.5 - $('.video-btn').height() * 0.5) + 'px')

    var historyRec = history_recs && history_recs[slidePos];
    let bb_data = historyRec.bbox_info ? JSON.parse(historyRec.bbox_info) : [];

    // if (historyRec.tracks_count > 0) {
    //   if (historyRec.tracker_data) {
    //     for (let b of historyRec.tracker_data) {
    //       bb_data.push({ c: b.class_name, x: b.bbox[0] / 1920, y: b.bbox[1] / 1080, w: ((b.bbox[2] - b.bbox[0]) / 1920), h: (b.bbox[3] - b.bbox[1]) / 1080 });
    //     }
    //   }
    // }

    let zone_selected = user.zone_selected;
    let people_detection = zone_selected && zone_selected.location_config ? zone_selected.location_config.feature_controls && zone_selected.location_config.feature_controls.motion_detection && zone_selected.location_config.feature_controls.motion_detection.enabled : true;

    if (bb_data && people_detection !== false) {
      console.log("bb_data....", bb_data);
      try {

        for (var bb of bb_data) {
          var w = $(currentImage).parent().width()
          var h = $(currentImage).parent().height();

          var div = document.createElement('div');
          div.className = 'bbox bbox_' + bb.c;
          var leftVal = (w * bb['x']);
          if (leftVal < 0) {
            leftVal = 0;
            bb['w'] = bb['w'] + (-bb['x'])
          }
          var widthVal = (w * bb['w']);
          if (widthVal > w) {
            widthVal = w;
          }
          div.setAttribute("style", "position: absolute; border: 2px solid #1dec23; width:" + widthVal + "px; height:" + (h * bb['h']) + "px; top:" + (h * bb['y']) + "px; left:" + leftVal + "px")
          $(div).appendTo($(currentImage).parent());
        }

      } catch (e) { }
    }
  };

  let fetchVehicleTrackingInfo = async (slidePos) => {
    if (!history_recs || !history_recs.length > 0 || !history_recs[slidePos])
      return;

    if (history_recs && history_recs[slidePos] && history_recs[slidePos].tracker_json) {
      console.log('Tracking info exists for ' + history_recs[slidePos].sec_timestamp);
      return;
    }

    if (!history_recs[slidePos].tracks_count || history_recs[slidePos].tracks_count < 1) {
      console.log('Tracking info not required for ' + history_recs[slidePos].sec_timestamp);
      return;
    }

    console.log('Fetching Tracking info for ' + history_recs[slidePos].sec_timestamp);
    let history_id = history_recs[slidePos].history_id;

    var data = {
      site_id: user.site_selected.site_id,
      user_login: user.user_login,
      user_token: user.user_token,
      location_id: user.zone_selected.location_id,
      sec_timestamp: history_recs[slidePos].sec_timestamp,
      bbox_category: 'vehicle'
    };
    $.ajax(
      {
        url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/bounding-boxes-info',
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(data)
      }
    ).then(
      (res) => {
        if (res.status && res.status.code === 200) {
          let history_rec = JSON.parse(JSON.stringify(history_recs));
          if (history_id === history_rec[slidePos].history_id)
            history_rec[slidePos].tracker_json = res.data.length > 0 ? res.data[0].tracker_json_new : [];
          setHistoryRecs(history_rec);
        }
      },
      (res) => {
      });
  }

  let applyVideoBoundingBoxes = (bb_data) => {
    try {
      $('.bbox-vehicle').remove();
      let currentImage = $('#video-player');
      for (var bb of bb_data) {
        var w = $(currentImage).parent().width()
        var h = $(currentImage).parent().height();

        var div = document.createElement('div');
        div.className = 'bbox bbox-vehicle bbox_' + bb.c;
        var leftVal = (w * bb['x']);
        if (leftVal < 0) {
          leftVal = 0;
          bb['w'] = bb['w'] + (-bb['x'])
        }
        var widthVal = (w * bb['w']);
        if (widthVal > w) {
          widthVal = w;
        }
        div.setAttribute("style", "position: absolute; border: 2px solid #1dec23; width:" + widthVal + "px; height:" + (h * bb['h']) + "px; top:" + (h * bb['y']) + "px; left:" + leftVal + "px")
        $(div).appendTo($(currentImage).parent());
      }
    } catch (e) { }
  }

  let prepareVideoBoundingBoxes = async () => {
    var historyRec = history_recs && history_recs[slidePos];
    if (historyRec && historyRec.tracks_count > 0) {
      if (!historyRec.tracker_json) {
        return
      }
      let tracker_json = JSON.parse(historyRec.tracker_json);
      let fps = 1000 / (tracker_json.rate_fps || 2);

      for (const td of tracker_json.tracker_data) {
        let bb_arr = [];
        for (const b of td.trackers) {
          bb_arr.push({ c: b.class_name, x: b.bbox[0] / 1920, y: b.bbox[1] / 1080, w: ((b.bbox[2] - b.bbox[0]) / 1920), h: (b.bbox[3] - b.bbox[1]) / 1080 });
        }
        setTimeout(() => {
          applyVideoBoundingBoxes(bb_arr);
        }, fps * td.frame_id);
      }
    }
  }

  let slideThumbnails = () => {
    let w = $('#img_thumbnail_' + slidePos)[0].offsetWidth;
    let l = $('#img_thumbnail_' + slidePos)[0].offsetLeft;
    let to = l - (w * 3);
    $($('.image-thumbnail-slider')[0]).animate({ scrollLeft: to }, 500);
  }

  let loadHighResolutionImage = (image) => {
    let ZoneImageObj = document.getElementById('zone-image');
    ZoneImageObj.setAttribute('src', image);
  }

  let playBtnClick = (e) => {
    $(e.target).closest('div').find('img').trigger('click');
  }

  let zoomIfMobile = () => {
    if ($(window).width() <= 768) { // max ipad size
      $('#zoom-control').trigger('click');
    }
  }

  let isWorkHours = (timestamp, site) => {

    let isWorkHour = false;
    let timezone = site.site_iana_timezone;
    if (!timezone)
      timezone = moment.tz.guess();

    if (holidays && holidays.length > 0) {
      let date = moment.tz(timestamp * 1000, timezone).format('YYYY-MM-DD');
      let isHoliday = holidays.find(h => h.date === date);
      if (isHoliday)
        return false;
    }

    let time = moment.tz(timestamp * 1000, timezone).format('HH:mm');
    let day = moment.tz(timestamp * 1000, timezone).format('dddd');

    let workHours = site.site_config.work_hours;
    if (workHours.extended_enabled) {
      for (const weekdays in workHours.work_schedule) {
        let event_day = day.toLowerCase();
        if (weekdays === event_day) {
          let work_hours = workHours.work_schedule[event_day];

          let HH = moment.tz(timestamp * 1000, timezone).format('HH');
          let mm = moment.tz(timestamp * 1000, timezone).format('mm');

          let wh_pos = parseInt(HH);
          if (work_hours.length > 24) {
            wh_pos = 2 * wh_pos;
            if (mm > 30)
              wh_pos = wh_pos + 1;
          }

          isWorkHour = work_hours[wh_pos] === 1;
          //console.log(HH + ':' + mm + ' is work hour ? ' + isWorkHour);
        }
      }
    } else {
      if (time > workHours.work_hours_start && time < workHours.work_hours_end) {
        let weekDay = workHours.include_weekends === "6" ? "saturday" : (workHours.include_weekends === "7" ? "sunday" : workHours.include_weekends === "6 7" ? "both" : "none");
        let todayDay = day.toLowerCase();
        if (todayDay !== weekDay) {
          if (weekDay === "both" || (weekDay === "none" && todayDay !== "saturday" && todayDay !== "sunday") || (todayDay !== "saturday" && todayDay !== "sunday")) {
            isWorkHour = true;
          }
        } else {
          isWorkHour = true;
        }
      } else {
        isWorkHour = false;
      }
    }
    return isWorkHour;
  }

  let createPattern = (color = 'black') => {
    // create a 10x10 px canvas for the pattern's base shape
    let shape = document.createElement('canvas')
    shape.width = 5
    shape.height = 5
    // get the context for drawing
    let c = shape.getContext('2d')
    // draw 1st line of the shape 
    c.strokeStyle = color
    c.beginPath()
    c.moveTo(1, 0)
    c.lineTo(5, 4)
    c.stroke()
    // draw 2nd line of the shape 
    c.beginPath()
    c.moveTo(0, 4)
    c.lineTo(1, 5)
    c.stroke()
    // create the pattern from the shape
    return c.createPattern(shape, 'repeat')
  }

  let iOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  let isHistoricalAllowed = user.zone_selected.location_features && user.zone_selected.location_features.includes('l1');
  let content = null
  if (!isHistoricalAllowed && user.zone_selected.location_device_type && ['axis', 'uniview'].includes(user.zone_selected.location_device_type))
    isHistoricalAllowed = user.zone_selected.location_operstatus === 'Connected' ? true : false;

  if (history_recs) {
    let zoneRecTimeStamp = '';
    let historyRec = history_recs.length > 0 ? history_recs[slidePos || 0] : null;

    let sensorData = [];
    let sensorInfo = {};
    var sensorCombi = {};
    var sensorCount = 0;
    if (historyRec) {
      sensorData = historyRec.sensor_info ? JSON.parse(historyRec.sensor_info) : [];
      for (let s of sensorData) {
        let combi = (s.device_id + '-' + s.name);
        let d = sensorCombi[combi];
        if (!d) {
          d = sensorCombi[combi] = (s.device_id === s.name) ? 'Gateway' : 'Sensor ' + (++sensorCount);
        }

        if (!sensorInfo[d])
          sensorInfo[d] = [];

        sensorInfo[d].push(s); // Store object with device id.
        if (s.sensor_id === 'temperature' || s.sensor_id === 'humidity') {
          if (!historyRec[s.sensor_id] || d === 'Gateway') // overwrite if gateway
            historyRec[s.sensor_id] = (Math.round(s.value, 2));
        }
      }
      zoneRecTimeStamp = moment.tz(historyRec.sec_timestamp * 1000, timezone).format('MMM DD, YYYY HH:mm');
    }

    let historic_slider_ts;
    if (isHistoricalAllowed) {
      historic_slider_ts = historyRec !== undefined && historyRec ? [historyRec.sec_timestamp || historyRec.dev_timestamp] : null;
      let prevSlideZoneRec = slidePos > 0 ? zone_history[parseInt(slidePos - 1)] : null;
      try {
        let timestamp2 = prevSlideZoneRec ? (prevSlideZoneRec.sec_timestamp === 0 ? prevSlideZoneRec.dev_timestamp : prevSlideZoneRec.sec_timestamp) : moment.tz(historic_slider_ts[0] * 1000, timezone).startOf('day').format('X');
        if (timestamp2 < historic_slider_ts[0])
          historic_slider_ts.unshift(parseInt(timestamp2));
        else
          historic_slider_ts.push(parseInt(timestamp2));
      } catch (e) {
      }
    }
    fetchVehicleTrackingInfo(slidePos);
    content = history_recs && history_recs.length > 0 ? (
      <div className="p-2">
        <div className="row">
          <div className="col-md-12 p-0">

            <div className="hover-transparent" style={{ position: "absolute", margin: "-1px", background: '#ffffff', textAlign: 'left', padding: '5px 15px', minWidth: user.zone_selected.location_device_type ? (window.innerWidth > 1000 ? '230px' : '0px') : '0px' }}>
              <span className="text-dark font-size-14" style={{ fontSize: "14px" }}>{moment.tz(historyRec && historyRec.dev_timestamp * 1000, timezone).format('MMM DD, YYYY  HH:mm:ss')}</span>
              <span className='font-size-12 ml-4'>

                <span className="text-primary ml-2">
                  {CommonUtils.formatSensorData('temperature', historyRec.temperature)}
                </span>
                <span className="ml-3 text-primary ml-1 text-info">
                  {CommonUtils.formatSensorData('humidity', historyRec.humidity)}
                </span>
              </span>
            </div>

            <span onClick={() => onPrevClick()} className="cursor-pointer align-vc" >
              <i className='fa fa-lg fa-chevron-left text-light px-2'></i>
            </span>

            <span onClick={() => onNextClick()} className="cursor-pointer align-vc" style={{ right: '0px' }}>
              <i className='fa fa-lg fa-chevron-right text-light px-2'></i>
            </span>

            {historyRec && historyRec.video &&
              <span className="onplay-video-hide video-btn" style={{ position: 'absolute', width: '50px', left: 0, right: 0, margin: 'auto', top: '50%' }}>
                <Modal ref={x => video_ref = x} size="modal-dialog modal-xl" title={historyRec.tracks_count > 0 ? historyRec.tracker_json && <img className='cursor-pointer video-icon' style={{ position: 'relative', zIndex: 100 }} alt="" src={video_icon} height="48"></img> : <img className='cursor-pointer video-icon' style={{ position: 'relative', zIndex: 100 }} alt="" src={video_icon} height="48"></img>}>
                  <>
                    <button type="button" style={{ position: 'absolute', zIndex: 2000, right: '0px', margin: '5px', width: '30px' }} className='btn btn-sm btn-danger' data-dismiss="modal" aria-label="Close" onClick={() => video_ref.closeModal()}>X</button>
                    <video id="video-player" onPlaying={(e) => prepareVideoBoundingBoxes()} width="100%" controls autoPlay="autoplay" src={historyRec.video} />
                  </>
                </Modal>
              </span>
            }

            {
              is_axis_camera && CommonUtils.hasPermission('SITESUPT-UI-DVR-DETAILS') && <span data-toggle="tooltip" title="DVR Details" style={{ position: 'absolute', paddingTop: '4px', right: '160px', zIndex: 400 }}>
                <button className="btn btn-sm btn-primary mr-1 ml-2" onClick={() => getDVRDetails()}><i className="fa fa-compact-disc"></i> DVR</button>
              </span>
            }

            {
              isHistoricalAllowed && (is_axis_camera ? recording !== undefined : true) &&
              <Modal tooltip-title="Historical Videos" ref={React.createRef()} id="historical-video" size="modal-dialog modal-xl" style={{ position: 'absolute', paddingTop: '4px', right: '80px', zIndex: 400 }} title={<span className="btn btn-sm btn-primary mr-1 ml-2" id="historical-video-control"><i className="fa fa-video"></i></span>}>
                <ZoneHistoricalVideo recording={recording} timestamps={timestamps || []} refreshZoneHistory={refreshZoneHistory} date={new Date().getTime()} zone={user.zone_selected} timezone={timezone} timestampRange={historic_slider_ts} historyRec={historyRec} />
              </Modal>
            }

            <Modal tooltip-title="Zoom Image" ref={React.createRef()} size="modal-dialog modal-fullscreen-70" style={{ position: 'absolute', paddingTop: '4px', right: '40px', zIndex: 400 }} title={<span className='btn btn-sm btn-primary mr-1 ml-2' onClick={(e) => { $(e.target).find('i').trigger('click') }}><span id="zoom-control"><i className='fa fa-search-plus color-white'></i></span></span>}>
              <ZoneHistoryImage zone_name={user.zone_selected.location_name} zone_hisory_rec={historyRec} zone_rec_timestamp={zoneRecTimeStamp} />
            </Modal>

            <span style={{ position: 'absolute', paddingTop: '4px', right: '0px', zIndex: 400 }} data-toggle="tooltip" title="Download Image">
              <span className='btn btn-sm btn-primary mr-1 ml-2' onClick={(e) => { $("[data-toggle='tooltip']").tooltip('hide'); $(e.target).find('i').trigger('click'); }}>
                <a href={historyRec && historyRec.image}><i className='fa fa-download color-white'></i></a>
              </span>
            </span>

            <Swipeable
              trackMouse
              preventDefaultTouchmoveEvent
              onSwipedLeft={onNextClick}
              onSwipedRight={onPrevClick}
            >
              <div id="image_container" >
                <div className="align-vc" style={{ textAlign: 'center', width: '100%' }}>
                  {/* {img_loading && <Loading className="text-white"><span className="text-white">Loading high resolution image ...</span></Loading>} */}
                </div>
                <img sec_timestamp={historyRec && historyRec.sec_timestamp} onClick={zoomIfMobile} id="zone-image" onLoad={(e) => {
                  if (historyRec.image_thumbnail) {
                    if (e.target.src.includes('thumb') || e.target.src.includes('data:image')) { applyBoundingBoxes(); }
                    if (e.target.src.includes('thumb')) { loadHighResolutionImage(historyRec.image); }
                  }
                }} className='card-img-top' src={historyRec ? historyRec.image_thumbnail || no_image : ''} alt='' />
              </div>
            </Swipeable>
          </div>
          <div className="col-md-12 p-0">
            <div className="row">
              <div className="col-md-12">
                <div className="d-flex image-thumbnail-slider" style={{ overflowX: 'scroll', whiteSpace: 'nowrap' }}>
                  <Swipeable
                    trackMouse
                  // onSwipedLeft={onSwipeClickNext}
                  // onSwipedRight={onSwipeClickPrev}
                  >
                    {
                      history_recs.map((zoneRec, recs_pos) => (
                        <React.Fragment key={recs_pos}>
                          <LazyLoadImage
                            id={"img_thumbnail_" + recs_pos}
                            load={true}
                            pos={recs_pos}
                            onClick={onImageThumbnailClick}
                            containerClassName={zoneRec && zoneRec.video ? 'd-inline video_thumbnail' : 'd-inline'}
                            className={'cursor-pointer img_thumbnail ' + (slidePos + '' === recs_pos + '' ? ' border border-warning border-2 curr-image-thumbnail' : ' border border-white border-2')}
                            src=''
                            width={thumbnailWidth}
                            path={zoneRec.image_thumbnail || no_image}
                            content={zoneRec && zoneRec.video &&
                              <img className='play-btn' onClick={playBtnClick} src={video_icon} with="24" height="18" alt=""></img>
                            } />
                        </React.Fragment>
                      ))
                    }
                  </Swipeable>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                {datasets && datasets.length > 0 &&
                  <div className="chart_slider" style={{ overflowX: "scroll" }}>
                    <div style={{ width: `${(labels.length * 50) + 'px'}` }}>
                      <div className='sitekick-chart'>
                        {datasets[0].map((val, i) => {
                          let persons = datasets[1][i];
                          let trucks = datasets[2][i]; //history_recs && history_recs[i] && history_recs[i].tracks_count ? 1 : 
                          let vehiclesFound = history_recs && history_recs[i] && history_recs[i].tracks_count ? 1 : 0;
                          // let trucks = datasets[4][i];
                          // console.log(datasets[4]);

                          let p = (persons / maxSize) * 100; // person
                          let t = (trucks / maxSize) * 100; // truck
                          let v = (datasets[0][i] / maxSize) * 100; // video

                          let p_t = p + t;

                          let pt = [];
                          if (p > t) {
                            pt = [
                              <div key={'persons'} w={persons} className='bar text-center' style={{ background: COLORS.PEOPLE, height: (p_t + 1 - t) + '%' }}>{p > 0 && <i className="fas text-white fa-walking"></i>}</div>,
                              <div key={'trucks'} w={trucks} className='bar text-center' style={{ background: COLORS.VEHICLE, height: (p_t - p) + '%', marginTop: '0px' }}>{t > 0 && <i className="fas text-white fa-car"></i>}</div>
                            ]
                          } else {
                            pt = [
                              <div key={'trucks'} w={trucks} className="bar text-center" style={{ background: COLORS.VEHICLE, height: (p === t ? 1 : p_t + 1 - p) + '%' }}>{t > 0 && p !== t && <i className="fas text-white fa-car"></i>}</div>,
                              <div key={'persons'} w={persons} className="bar text-center" style={{ background: COLORS.PEOPLE, height: (p_t - t) + '%', marginTop: '0px' }}>{p > 0 && <i className="fas text-white fa-walking"></i>} {t > 0 && p === t && <i className="fas text-white fa-car"></i>}</div>
                            ]
                          }

                          let isOffWorkHrs = workHourMap[i] === COLORS.OFFWORK;
                          let pClass = isOffWorkHrs ? 'off-workhrs-bg' : 'workhrs-bg';
                          let tooltipContent = (
                            <div key={'tooltip' + i} className='text-left text-black'>
                              <div><i className="far fa-clock"></i> {labels[i]}</div>
                              {persons > 0 && <div>{isOffWorkHrs ? <i className='fa fa-square fa-lg' style={{ color: COLORS.PEOPLE }} /> : <i className="fa fa-square fa-lg " style={{ color: COLORS.PEOPLE }} ></i>} Persons: {persons}</div>}
                              {trucks > 0 && <div>{isOffWorkHrs ? <i className='fa fa-square fa-lg' style={{ color: COLORS.VEHICLE }} /> : <i className="fa fa-square fa-lg " style={{ color: COLORS.VEHICLE }} ></i>} Vehicles:  {trucks > 0 ? trucks : (vehiclesFound ? 'Found' : 'Not Found')}</div>}
                            </div>);
                          let isMobile = $('.menu_bars')[0].offsetLeft > 0 || navigator.userAgent.match(/iPad/i) || iOS();
                          return <Tooltip trigger={isMobile ? 'click' : 'hover'} overlayClassName={"chart-tooltip"} key={"bar" + i} arrow={"true"} placement="top" title={tooltipContent}>
                            <div w={maxSize} onClick={(e) => setSlidePos(i)} pos={i} className={'bar parent-bar ' + pClass} style={{ height: '100%', border: '1px solid ' + (slidePos === i ? 'orange' : '#2c2e33') }}>
                              {datasets[0][i] > 0 && <div height={v + '%'} className='iceberg' w={datasets[0][i]}></div>}
                              {pt}
                              <div style={{ margin: "-1px" }} className="bg-white text-center text-app">{labels[i]}</div>
                              <div className='hide'>{tooltipContent}</div>
                            </div>
                          </Tooltip>
                        })}
                      </div>

                    </div>
                  </div>
                }
              </div>

            </div>
            <div className="row">
              <div className='col-12 text-center'><b>Hour</b></div>
            </div>
            <div className="row pt-2">
              <div className="col-md-12 mt-2 pl-4 text-app text-center">
                <label className='mr-3'>People: <i className="fa fa-square fa-lg" style={{ color: COLORS.PEOPLE, cursor: "auto" }}></i></label>
                <label className='mr-3'>Vehicle: <i className="fa fa-square fa-lg" style={{ color: COLORS.VEHICLE, cursor: "auto" }}></i></label>
                <label className='mr-3'>Video: <img src={video_icon} alt='' style={{ width: "24px", height: "18px", paddingBottom: "2px" }}></img></label>
                <label className='mr-3'>Work Hours: <button style={{ minWidth: '18px', 'width': '18px', height: '18px', display: 'inline', cursor: "auto" }} className="btn striped1">&nbsp;</button> </label>
                <label className='mr-3'>Off-Work Hours: <i className="fa fa-square fa-lg" style={{ color: COLORS.WORK, cursor: "auto" }}></i></label>
              </div>
            </div>

            <div className='p-0 mt-3'>
              {
                historyRec && historyRec.sensor_info && !props.hideNotification &&
                <table width="100%" className='table table-striped table-custom table-bordered border-radius-tb'>
                  <thead className='text-white bg-primary'>
                    <tr>
                      <th width='150px'>Notification Type</th>
                      <th>Detail</th>
                    </tr></thead>
                  <tbody className='text-dark bg-white font-size-13'>
                    {
                      Object.keys(sensorInfo).sort(function (a, b) {
                        var x = (a === 'Gateway') ? 'A' + a : a;
                        var y = (b === 'Gateway') ? 'A' + b : b;
                        return x > y ? 1 : (x < y ? -1 : 0);
                      }).map((device_id, d) => (
                        sensorInfo[device_id].sort(function (x, y) {
                          var sortOrder = ['temperature', 'humidity', 'person', 'motion', 'co', 'co2', 'voc'];
                          var a = sortOrder.indexOf(x.sensor_id.toLowerCase());
                          var b = sortOrder.indexOf(y.sensor_id.toLowerCase());
                          return a < b ? -1 : a > b ? 1 : 0;
                        }).map((sensor_rec, s) => {
                          let rec = (
                            <tr key={s}>
                              <td className='text-capitalize'>{(['co', 'co2', 'voc'].indexOf(sensor_rec.sensor_id) !== -1) ? sensor_rec.sensor_id.toUpperCase() : sensor_rec.sensor_id}</td>
                              <td>
                                {sensor_rec.sensor_id === 'person' && (sensor_rec.value === 'People detected' ? 'Core Crew Member' : sensor_rec.value)}
                                {sensor_rec.sensor_id === 'motion' && (sensor_rec.value === '0' ? 'Off' : sensor_rec.value.length === 10 ? moment.tz(parseInt(sensor_rec.value) * 1000, timezone).format('MMM DD, YYYY HH:mm') : zoneRecTimeStamp)}

                                {(sensor_rec.sensor_id === 'co' || sensor_rec.sensor_id === 'voc' || sensor_rec.sensor_id === 'co2' || sensor_rec.sensor_id === 'humidity' || sensor_rec.sensor_id === 'temperature') && (Math.round(sensor_rec.value, 2) === -100 ? "NA" : Math.round(sensor_rec.value, 2))}
                                {sensor_rec.sensor_id === 'temperature' ? Math.round(sensor_rec.value, 2) === -100 ? '' : ' °F' :
                                  sensor_rec.sensor_id === 'humidity' ? Math.round(sensor_rec.value, 2) === -100 ? '' : ' %' :
                                    sensor_rec.sensor_id === 'co2' ? ' ppm' :
                                      sensor_rec.sensor_id === 'co' ? ' ppm' :
                                        sensor_rec.sensor_id === 'voc' ? ' ppb' : ''}
                              </td>
                            </tr>
                          );

                          return s === 0 ? (
                            <React.Fragment key={s}>
                              <tr>
                                <td className="font-weight-bold">{device_id} <span className='pull-right'>{sensor_rec.device_id !== sensor_rec.name && <ZoneSensorBattery sensor_name={sensor_rec.name} />}</span></td>
                                <td>
                                  <div className="row">
                                    <div className={device_id === 'Gateway' ? 'hide' : 'col-md-3'}><b>Name</b>: {sensor_rec.name}</div>
                                    <div className="col-md-6"><b>Last Update</b>: {sensor_rec.lastupdate ? moment.tz(sensor_rec.lastupdate * 1000, timezone).format('YYYY-MM-DD HH:mm') :
                                      moment.tz(sensor_rec.when * 1000, timezone).format('YYYY-MM-DD HH:mm')}</div>
                                  </div>
                                </td>
                              </tr>
                              {!user.zone_selected.location_device_type && rec}
                            </React.Fragment>

                          ) :
                            !user.zone_selected.location_device_type && rec
                        })
                      ))
                    }
                  </tbody>
                </table>
              }
            </div>
          </div>
        </div >
      </div >
    ) : ' Zone History Not Found!';
  }
  return (
    <div className="row bg-white border-rounded">
      <div className="col-lg-12" id="carousel_container">
        {content || <div className='pt-2'><Loading> Fetching Zone History ...</Loading></div>}
      </div>
    </div>
  )
}

export default ZoneHistoryCarousel;